<template>
	<v-sheet elevation="0" max-width="700px" class="mx-auto">
		<FunctionTitle :title="''" />
		<CommonFlame :title="'パスワード再設定'">
			<v-sheet elevation="0" class="mt-4">
				<p class="notes">
					パスワードを忘れた場合、再設定が可能です。
					<br />
					下のフォームに登録したメールアドレスを入力してください。
					<br />
					再設定フォームへのリンクを送信いたします。
				</p>
				<v-form ref="form" v-model="valid">
					<v-text-field
						v-model="email"
						label="メールアドレス"
						class="mt-4"
						type="email"
						:rules="[rules.required, rules.emailFormat]"
						required
						dense
						outlined
					></v-text-field>
					<ul class="error-message" v-if="errors.length">
						<li v-for="(error, i) in errors" :key="i">
							{{ error }}
						</li>
					</ul>
					<v-row justify="center">
						<v-btn class="my-4" color="secondary" @click.prevent="sendMail" :disabled="!valid">
							パスワードを再設定する
						</v-btn>
					</v-row>
				</v-form>
			</v-sheet>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import rules from "../../helper/rules"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			valid: false,
			email: null,
			rules: rules,
			errors: [],
			reset_password_token: null,
		}
	},
	mounted() {
		this.reset_password_token = this.$route.query.reset_password_token
	},
	methods: {
		sendMail() {
			this.errors = []

			axios
				.post("/erp/v1/auth/password", {
					email: this.email,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "パスワード再設定メールが送信されました。",
						type: "notice",
					})
				})
				.catch((err) => {
					if (err.response?.status == 404) {
						var message = "メールアドレスが見つかりませんでした。"
					} else {
						var message = "エラーが発生しました。"
					}
					this.$store.dispatch("setFlash", {
						type: "alert",
						text: message,
					})
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../stylesheet/erp/passwords.scss";
</style>
